import React from 'react';
import { Link } from 'react-router-dom';
import { Home as HomeIcon, PartyPopper, ArrowRight } from 'lucide-react';
import SubpageShell from './SubpageShell';
import SEO from '../components/SEO';
import '../styles/ServiceEnquiry.css';

/**
 * /experiences — landing hub for Home Experiences and Celebrations & Events.
 * Both children lead to a dedicated service page with an enquiry form.
 */
const Experiences = () => (
  <SubpageShell currentPath="/experiences">
    <SEO
      title="N3URO Experiences — Private, neuro-inclusive family experiences"
      description="Private, themed, immersive family experiences at home and extraordinary celebrations designed with everyone in mind."
      canonical="/experiences"
      image="https://n3uro.world/img/share-experiences.jpg"
    />
    <main className="subpage-hero">
      <span className="subpage-eyebrow">N3URO Experiences</span>
      <h1 className="subpage-title">Private, neuro-inclusive family experiences.</h1>
      <p className="subpage-lede">
        Two ways to discover together: at home, or as an extraordinary occasion. Choose the path that
        suits your family — we handle the design, hosting and sensory considerations.
      </p>

      <section className="service-grid" aria-label="Experience services">
        <Link to="/experiences/home" className="service-card" style={{ '--accent': '#5BE9FF' }} data-testid="card-experiences-home">
          <img className="service-card-media" src="/img/experiences-home-thumb.webp" alt="" loading="lazy" data-testid="card-experiences-home-image" />
          <span className="service-card-icon" aria-hidden="true"><HomeIcon size={22} strokeWidth={1.75} /></span>
          <h3>Experiences at Home</h3>
          <p>Bring discovery into your own environment. Private themed sessions — immersive, interactive, educational and family-paced.</p>
          <span className="service-card-link">Explore home experiences <ArrowRight size={14} strokeWidth={2.4} /></span>
        </Link>

        <Link to="/experiences/events" className="service-card" style={{ '--accent': '#FF6BC2' }} data-testid="card-experiences-events">
          <img className="service-card-media" src="/img/experiences-events-thumb.webp" alt="" loading="lazy" data-testid="card-experiences-events-image" />
          <span className="service-card-icon" aria-hidden="true"><PartyPopper size={22} strokeWidth={1.75} /></span>
          <h3>Celebrations &amp; Events</h3>
          <p>Extraordinary occasions designed with everyone in mind — birthdays, family celebrations and private themed events.</p>
          <span className="service-card-link">Plan an event <ArrowRight size={14} strokeWidth={2.4} /></span>
        </Link>
      </section>
    </main>
  </SubpageShell>
);

export default Experiences;
